<style scoped>
.Grid {

}

.Grid--line {
  display: flex;
}

.Grid--column {
  width: 8px;
  height: 8px;
  background: #ffffff;
  margin: 8px;
  opacity: 0.25;
  border-radius: 100px;
  transition: opacity 1000ms, transform 1000ms;
  transform: scale(1) translate(0px, 0px);
}

.Grid--column-selected {
  opacity: 0.70;
  transform: scale(1.25) translate(2px, -2px);
}

.even {
  margin-left: 10px;
}
</style>

<template>
  <div class="Grid">
    <div class="Grid--line" v-for="(line, y) in state.lines" :class="isOdd(y%2 == 0)">
      <div class="Grid--column" v-for="(column, x) in line.columns" :class="class_column(x, y, column)">
        <!--        {{ column.life }}-->
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    column: {
      type: Number,
      default: () => 7
    },
    line: {
      type: Number,
      default: () => 7
    },
    size: {
      type: Number,
      default: () => 20
    },
    speed: {
      type: Number,
      default: () => 100
    },
    bounce: {
      type: Number,
      default: () => 1000
    }
  },
  data() {
    return {
      state: {
        lines: [],
        currentY: 0,
        currentX: 0
      }
    }
  },
  mounted() {
    this.state.lines = this.buildLines()
    this.animate()
  },
  methods: {
    class_column(x, y, column) {
      let classes = []
      if (column.life > 0 || (x === this.state.currentX && y === this.state.currentY)) {
        classes.push(`Grid--column-selected`)
        if (column.life === 0) column.life = this.size
      }
      return classes
    },
    buildLines() {
      const lines = []
      for (let y = 0; y < this.line; y++) {
        const columns = []
        for (let x = 0; x < this.column; x++) {
          columns.push({
            life: 0,
            classes: []
          })
        }
        lines.push({
          columns
        })
      }
      return lines
    },
    isOdd(odd) {
      if(odd) {
        return '';
      } else {
        return 'even';
      }
    },
    animate() {
      let x = this.state.currentX
      let y = this.state.currentY

      x++

      this.state.currentX = x

      if (x >= this.column) {
        this.state.currentX = 0
        y++
      }

      this.state.currentY = y

      if (y >= this.line) {
        this.state.currentY = 0
      }

      this.deleteLife()

      setTimeout(() => this.animate(), this.speed)

    },
    deleteLife() {
      for (let y = 0; y < this.line; y++) {
        for (let x = 0; x < this.column; x++) {
          if (this.state.lines[y].columns[x].life > 0) {
            this.state.lines[y].columns[x].life--
          }
        }
      }
    }
  }
}
</script>